export enum CardNetwork {
    VISA = 'visa',
    MASTERCARD = 'mastercard',
    MAESTRO = 'maestro',
    AMEX = 'amex',
    DINERS = 'diners',
    DISCOVER = 'discover',
    JCB = 'jcb',
    ELO = 'elo',
    UNIONPAY = 'unionpay',
    MIR = 'mir',
    RUPAY = 'rupay',
}